import { clsx } from 'clsx'
import { Shield } from 'lucide-react'

/**
 * CertShieldPro wordmark, adapted from src/components/brand/Logo.tsx to fit the
 * Radiant `Logo` API (sized by height via className, no inner link — the Navbar
 * and Footer wrap it in a Link themselves).
 */
export function Logo({
  className,
  dark = false,
}: {
  className?: string
  dark?: boolean
}) {
  return (
    <span
      className={clsx(className, 'inline-flex items-center gap-2')}
      aria-label="CertShieldPro"
    >
      <span
        className={clsx(
          'flex aspect-square h-full items-center justify-center rounded-lg',
          dark ? 'bg-white' : 'bg-indigo-700',
        )}
      >
        <Shield
          className={clsx('size-[58%]', dark ? 'text-indigo-700' : 'text-white')}
          aria-hidden="true"
        />
      </span>
      <span
        className={clsx(
          'font-display text-xl font-semibold tracking-tight',
          dark ? 'text-white' : 'text-gray-950',
        )}
      >
        CertShieldPro
      </span>
    </span>
  )
}
